import { DateTimePicker, DateTimePickerProps } from '@mantine/dates';

const CustomDateTimePicker = (props: DateTimePickerProps) => (
    <DateTimePicker
      highlightToday={true}
      withSeconds={false}
      withAsterisk={props.required}
      onDateChange={props.onChange}
      clearable={true}
      {...props}
    />
);

export default CustomDateTimePicker;